import type { IncidentListItem } from '@prerender/diagnostics-api';

export type DomainSummary = {
  domains: string;
  stillAffected: string | null;
};

type SummarisedIncident = Pick<
  IncidentListItem,
  'headlineDomain' | 'otherDomainCount' | 'affectedDomainCount' | 'domainCount'
>;

export function domainSummary(incident: SummarisedIncident): DomainSummary {
  if (incident.domainCount <= 1) {
    return { domains: incident.headlineDomain, stillAffected: null };
  }

  return {
    domains: `${incident.headlineDomain} +${incident.otherDomainCount}`,
    stillAffected: `${incident.affectedDomainCount} of ${incident.domainCount} still affected`,
  };
}
